import { RemoteJobTableHeader, RemoteJobTableHeaderProps, RemoteNewRunModalProps } from "@/features/remote_jobs";
import { PortfolioExportNewRunModal } from "@/tools/aggregate/portfolio-export/components/PortfolioExportNewRunModal";
import { PortfolioExportJobSchema } from "@/tools/aggregate/portfolio-export/types";
import { useRouter } from "next/router";
import { FC, MutableRefObject, useRef, useState } from "react";
export type PortfolioHeaderRefs = {
  newRunModalTrigger: MutableRefObject<null>;
  alertBellTrigger: MutableRefObject<null>;
  newRunModal: {
    upload?: {
      fileUpload: MutableRefObject<null>;
      customiseTrigger?: MutableRefObject<null>;
      downloadTemplateTrigger: MutableRefObject<null>;
    };
    review?: {
      info: MutableRefObject<null>;
      advancedSettings: MutableRefObject<null>;
      usage: MutableRefObject<null>;
      runAnalysisTrigger: MutableRefObject<null>;
    };
  };
};

/**
 * Header for the Portfolio Export tool's table.
 */
export const PortfolioExportTableHeader = ({
  availablePortfolioTypes,
  creatablePortfolioTypes,
  ...props
}: RemoteJobTableHeaderProps<PortfolioExportJobSchema> & {
  availablePortfolioTypes: string[];
  creatablePortfolioTypes: string[];
}) => {
  const router = useRouter();
  const openModalByDefault = Object.keys(router.query).includes("handoff");
  const availablePortfolioTypesRef = useRef(availablePortfolioTypes);
  availablePortfolioTypesRef.current = availablePortfolioTypes;
  const creatablePortfolioTypesRef = useRef(creatablePortfolioTypes);
  creatablePortfolioTypesRef.current = creatablePortfolioTypes;
  const [NewRunModal] = useState(() => (modalProps: RemoteNewRunModalProps<PortfolioExportJobSchema>) => <PortfolioExportNewRunModal {...modalProps} availablePortfolioTypes={availablePortfolioTypesRef.current} creatablePortfolioTypes={creatablePortfolioTypesRef.current} />);
  const disableNewRun = creatablePortfolioTypes.length === 0;
  return <RemoteJobTableHeader {...props} newRunModalComponent={NewRunModal as FC} requestNotification={true} openModalByDefault={openModalByDefault} disableNewRun={disableNewRun} disableNewRunTooltip="You do not have permission to create new portfolios" data-sentry-element="RemoteJobTableHeader" data-sentry-component="PortfolioExportTableHeader" data-sentry-source-file="PortfolioExportTableHeader.tsx" />;
};